import { useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

import { landingUrls } from 'config/urls';
import { UserContext } from 'contexts/ConfigContext';
import { isSafePostLoginPath } from 'utils/postLoginRedirect';
import {
    buildUpdateActivityPayload,
    getStoredActivitySessionId,
    isActivityPathSkipped,
    resolveActivityMeta,
} from 'utils/recentActivity';

/**
 * Fire-and-forget visit logger. Mounted in the authenticated shell so every committed
 * route change can POST update_activity without blocking navigation.
 */
function RecentActivityTracker() {
    const location = useLocation();
    const { appConfig } = useContext(UserContext);
    const lastPostedRef = useRef('');

    useEffect(() => {
        const sessionId = getStoredActivitySessionId();
        const route = location.pathname;
        if (!sessionId || route === lastPostedRef.current) return;
        if (isActivityPathSkipped(route) || !isSafePostLoginPath(route)) return;
        const meta = resolveActivityMeta(route, appConfig);
        if (!meta) return;
        lastPostedRef.current = route;
        const payload = buildUpdateActivityPayload(sessionId, route, meta);
        axios.post(landingUrls.updateActivityUrl, payload).catch(() => undefined);
    }, [location.pathname, appConfig]);

    return null;
}

export default RecentActivityTracker;
